<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                基站管理
                <small>基站管理</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 基站管理
                    </a>
                </li>
                <li class="active">基站管理</li>
            </ol>
        </section>

        <!-- Main content -->
        <section class="content" style="background:#fff;">
            <div class="wrapper-content animated fadeInRight">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">
                        <div class="row row-lg">
                            <div class="col-sm-12">
                                <div id="atptoolbar">
                                    <!-- <button
                                      class="btn btn-success"
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#myModal"
                                      id="sys_search"
                                    >
                                      <i class="fa fa-search"></i>&nbsp;高级搜索
                                    </button>-->
                                    <select class="chosen-select-layer" name id v-model="layerid">
                                        <option value>请选择图层</option>
                                        <option
                                                v-for="(item,index) in layerlist"
                                                :key="index"
                                                :value="item.id"
                                        >{{item.name}}
                                        </option>
                                    </select>
                                    <button
                                            class="btn btn-info"
                                            type="button"
                                            id="sys_detai"
                                            @click="getStationId('stationDetails','show_sys_detai')"
                                    >
                                        <i class="fa fa-sign-in"></i>&nbsp;基站信息查询
                                    </button>
                                    <button
                                            class="btn btn-info"
                                            type="button"
                                            id="sys_detai"
                                            @click="getStationId('stationDetails','show_sys_detai')"
                                    >
                                        <i class="fa fa-sign-in"></i>&nbsp;编辑基站信息
                                    </button>
                                    <!-- <button
                                      class="btn btn-info"
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#sys_chat_modal"
                                      id="sys_chat"
                                    >
                                      <i class="fa fa-sign-in"></i>&nbsp;查看聊天记录
                                    </button>-->

                                    <button
                                            class="btn btn-warning"
                                            type="button"
                                            id="sys_see_ammeterrecord"
                                            @click="getStationId('seeAmmeterrecord','sys_see_ammeterrecord_modal')"
                                    >
                                        <i class="fa fa-sign-in"></i>&nbsp;电表查表记录
                                    </button>
                                    <!-- <button
                                      class="btn btn-warning"
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#sys_detail1"
                                      id="sys_update"
                                    >
                                      <i class="fa fa-pencil-square"></i>&nbsp;现网基站编辑
                                    </button>-->
                                    <!-- <button class="btn btn-danger" type="button" id="sys_del" @click="sys_del">
                                      <i class="fa fa-eraser"></i>&nbsp;基站删除
                                    </button>-->
                                    <!--<button class="btn btn-info " type="button" id="sys_imp"><i class="fa fa-sign-in"></i>&nbsp;现网基站批量导入</button>-->
                                    <!-- <button class="btn btn-info" type="button" id="sys_down" @click="sys_down">
                                      <i class="fa fa-sign-in"></i>&nbsp;续签基站导出
                                    </button>-->
                                    <button
                                            class="btn btn-info"
                                            type="button"
                                            id="show_ammeter"
                                            @click="getStationId('ammetergraph','show_ammeter_graph')"
                                    >
                                        <!--  data-toggle="modal"
                                        data-target="#show_ammeter_graph"-->
                                        <i class="fa fa-sign-in"></i>&nbsp;显示电表拓扑图
                                    </button>
                                    <button
                                            class="btn btn-info"
                                            type="button"
                                            data-toggle="modal"
                                            id="addStation"
                                            @click="showModal('addstation','sys_addstation_modal')"
                                    >
                                        <!-- data-target="#sys_addstation_modal" -->
                                        <i class="fa fa-sign-in"></i>&nbsp;添加基站
                                    </button>
                                    <button
                                            class="btn btn-info"
                                            type="button"
                                            id="show_ammeter"
                                            @click="getStationId('addammeter','addammeter_modal')"
                                    >添加电表
                                    </button>
                                    <!-- <button
                                      class="btn btn-info"
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#show_ammeter_graph"
                                      id="show_ammeter"
                                    >
                                      <i class="fa fa-sign-in"></i>&nbsp;片区管理
                                    </button>-->
                                </div>
                                <table id="stationManager_atptable" data-show-columns="true"></table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <router-view/> -->
        <!-- /.content -->
        <!-- 模态框 -->
        <v-advancedsearch></v-advancedsearch>
        <v-stationDetails :msg-stationid="stationid" ref="stationDetails"></v-stationDetails>
        <v-chatHistory></v-chatHistory>
        <v-seeAmmeterrecord :msg-stationid="stationid" ref="seeAmmeterrecord"></v-seeAmmeterrecord>
        <v-ammetergraph :msg-stationid="stationid" ref="ammetergraph"></v-ammetergraph>
        <v-addstation :msg-stationid="stationid" ref="addstation"></v-addstation>
        <v-addammeter :msg-station="stationInfo" ref="addammeter"></v-addammeter>
        <div class="layerImg" @click="closeImg" style="display:none;">
            <img :src="layerimgUrl" alt="">
        </div>
    </div>
</template>
<script>
  import Vue from 'vue'
  import advancedSearch from '../views/stationmanager/advancedSearch' // 高级搜索
  import stationDetails from '../views/stationmanager/stationDetails' // 基站信息查询
  import chatHistory from '../views/stationmanager/chathistory' //聊天记录
  import seeAmmeterrecord from '../views/stationmanager/seeammeterrecord' // 查表记录
  import ammetergraph from '../views/stationmanager/ammetergraph' // 拓扑图
  import addstation from '../views/stationmanager/addstation' // 添加基站
  import addammeter from './stationmanager/addammeter' // 添加电表

  export default {
    name: 'stationManager',
    data () {
      return {
        imgSrc: '123', //图片弹框src
        hiddenLayer: true, // 隐藏图片弹出框
        stationid: '', // 基站id
        layerlist: [], // 所有图层
        layerid: '',
        org_id: '', //公司id
        stationInfo: {}, // 基站信息
        layerimgUrl: '',   // 放大图片的路径
      }
    },
    components: {
      'v-advancedsearch': advancedSearch,
      'v-stationDetails': stationDetails,
      'v-chatHistory': chatHistory,
      'v-seeAmmeterrecord': seeAmmeterrecord,
      'v-ammetergraph': ammetergraph,
      'v-addstation': addstation,
      'v-addammeter': addammeter
    },
    mounted () {
      var self = this
      var company = localStorage.getItem('companyInfo')
      self.org_id = JSON.parse(company).id
      $('.chosen-select-layer')
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: '200px'
        })
        .change(function () {
          self.layerid = $('.chosen-select-layer').val()
          // 选择图层
          self.getlist(self.layerid)
        })
      self.getlayer()
      self.getlist()
    },
    methods: {
      // 获取基站id param(方法名,模态框id)
      getStationId: function (funcname, eleid) {
        var self = this
        var tablerow = $('#stationManager_atptable').bootstrapTable('getSelections')
        console.log(tablerow)
        if (tablerow.length == 0) {
          alert('您尚未选择数据')
        } else {
          var stationid = tablerow[0].stst_atpid
          // console.log('基站id',stationid)
          self.stationid = stationid
          self.stationInfo = tablerow[0]
          setTimeout(function () {
            $('#' + eleid).modal('show')
            self.$refs[funcname].getData() // 调用子组件函数
          }, 1000)
        }
      },
      showModal: function (funcname, eleid) {
        var self = this
        $('#' + eleid).modal('show')
        self.$refs[funcname].getData() // 调用子组件函数
      },
      // 获取所有图层
      getlayer: function () {
        var self = this
        self.global.axiosGet(
          self,
          'organization/' + self.org_id + '/layers/',
          function (res) {
            console.log(res)
            self.layerlist = res
            setTimeout(function () {
              $('.chosen-select-layer').trigger('chosen:updated')
            }, 1000)
          }
        )
      },
      // 删除基站
      sys_del: function () {
        var tablerow = $('#stationManager_atptable').bootstrapTable('getSelections')
        if (tablerow.length == 0) {
          alert('您尚未选择数据')
        } else {
          if (confirm('确认删除' + tablerow.length + '条数据?')) {
            var ids = []
            $.each(tablerow, function () {
              ids.push(this['stst_atpid'])
            })
            self.axios
              .post('/static/stationInfo.json', { ids: ids.join(',') })
              .then(response => {
                var rep = response.data
                if ('' == rep) {
                  alert('提交成功，等待审核！')
                  $('#stationManager_atptable').bootstrapTable('refresh')
                } else {
                  alert(
                    '删除失败' +
                    '可能是因为数据存在关联无法删除<br>错误详情：' +
                    rep
                  )
                }
              })
          }
        }
      },
      //续签基站导出
      sys_down: function () {
        var tablerow = $('#stationManager_atptable').bootstrapTable('getSelections')
        if (tablerow.length == 0) {
          alert('您尚未选择数据')
        } else {
          var ids = []
          $.each(tablerow, function () {
            ids.push(this['stst_atpid'])
          })
          var formStr = ''
          var id = ids.join(',')
          var url = '__CONTROLLER__/submitdown'
          formStr =
            '<form  method="POST" action="' +
            url +
            '">' +
            '<input type="hidden" name="ststid" value="' +
            id +
            '" />' +
            '</form>'
          var form = $(formStr)
          $(document.body).append(form)
          form.submit()
        }
      },
      getlist: function () {
        var self = this
        $('#stationManager_atptable').bootstrapTable('destroy')
        $('#stationManager_atptable').bootstrapTable({
          url: self.global.apiHost + 'stations/', //请求后台的URL（*）
          method: 'get', //请求方式（*）
          ajaxOptions: {
            headers: {
              'content-type': 'application/json', // 默认值
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          },
          toolbar: '#atptoolbar', //工具按钮用哪个容器
          height: $(window).height() * 0.86,
          striped: true, //是否显示行间隔色
          cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
          pagination: true, //是否显示分页（*）
          iconSize: 'outline',
          sortable: true, //是否启用排序
          sortName: 'stst_atpid',
          sortOrder: 'DESC', //排序方式
          queryParams: self.queryParams, //传递参数（*）
          sidePagination: 'server', //分页方式：client客户端分页，server服务端分页（*）
          pageNumber: 1, //初始化加载第一页，默认第一页
          pageSize: 10, //每页的记录行数（*）
          pageList: [10], //可供选择的每页的行数（*）
          search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
          showColumns: true, //是否显示所有的列
          showRefresh: true, //是否显示刷新按钮
          minimumCountColumns: 2, //最少允许的列数
          clickToSelect: true, //是否启用点击选中行
          singleSelect: true,
          uniqueId: 'stst_atpid', //每一行的唯一标识，一般为主键列
          columns: [
            [
              { checkbox: true },
              {
                title: '序号',
                width: 40,
                formatter: function (value, row, index) {
                  var option = $('#stationManager_atptable').bootstrapTable('getOptions')
                  return option.pageSize * (option.pageNumber - 1) + index + 1
                }
              },
              {
                field: 'stst_commname',
                title: '基站名称',
                sortable: true
              },
              {
                field: 'stst_jtno',
                title: '金通号',
                sortable: true
              },

              {
                field: 'stst_type',
                title: '基站类型',
                sortable: true
              },
              {
                field: 'stst_longitude',
                title: '经度',
                sortable: true
              },
              {
                field: 'stst_latitude',
                title: '纬度',
                sortable: true
              },
              {
                field: 'stst_comm',
                title: '运营商',
                sortable: true
              },
              {
                field: 'stst_subcomm',
                title: '分管运营商',
                sortable: true
              },
              {
                field: 'stst_address',
                title: '地址',
                sortable: true
              },
              {
                field: 'stst_circuitdiagramtext',
                title: '供电线路说明',
                sortable: true,
                width: 150,
                visible: false
              },

              {
                field: 'stst_circuitdiagrampath',
                title: '供电线路图路径',
                sortable: true,
                width: 150,
                formatter: function (value, row, index) {
                  var a =
                    '<img src="' +
                    self.global.ossHost +
                    value +
                    '" style="height:50px;"/>'
                  if (null == value || '' == value) {
                    return ''
                  } else {
                    return a
                  }
                }
              },
              {
                field: 'stst_stationpicture',
                title: '基站照片',
                sortable: true,
                width: 150,
                formatter: function (value, row, index) {
                  // console.log('基站照片',value)
                  var ans =
                    '<img class=\'rowOperator\' src=\'' +
                    self.global.ossHost +
                    value +
                    '\' id=\'row' +
                    index +
                    '\'/ style=\'width:150px;height:150px;\'>'
                  if (null == value || '' == value) {
                    return ''
                  } else {
                    return ans
                  }
                }
              }
            ]
          ],
          onDblClickRow: function (row) {},
          onSort: function (name, order) {},
          onLoadSuccess: function () {
            $('#stationManager_atptable img').on('click', function () {
              var src = $(this).prop('src')
              self.layerimgUrl = src
              $('.layerImg').show()
            })
          },
          onClickRow: function (row, $element) {}
        })
      },
      queryParams: function (params) {
        params.layer_id = this.layerid
        params.org_id = this.org_id
        params.per_page = params.limit
        params.page = params.offset / params.limit + 1
        return params
      },
      //关闭图片
      closeImg: function () {
        $('.layerImg').hide()
        this.layerimgUrl = ''
      }
    }
  }
</script>
<style scoped>
    .layerImg {
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.2);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
    }

    .layerImg img {
        display: block;
        height: 100%;
        margin: 0 auto;
    }
</style>





// WEBPACK FOOTER //
// src/views/stationManager.vue